<template>
  <div class="px-4">
    <div v-for="product in productsOrder" :key="product.id">
      <div class="d-flex align-center justify-space-between mb-5">
        <div class="profile__container--content__orderhistory--details">
          <div class="d-flex align-center">
            <v-img
              v-if="!$vuetify.breakpoint.smAndDown"
              :width="56"
              cover
              :src="product.imageUrl"
            >
            </v-img>
            <div
              class="d-flex flex-column pl-3"
              :style="product.isDeleted ? 'text-decoration: line-through' : ''"
            >
              <v-hover v-slot="{ hover }">
                <p
                  class="font-weight-bold mb-0"
                  @click="productRedirect(product)"
                  :style="
                    hover ? 'cursor: pointer; text-decoration: underline' : ''
                  "
                >
                  {{ product.name }}
                </p>
              </v-hover>
              <div>
                  <p class="mb-0">{{ product.brandName }}</p>
              </div>
              <div
                v-if="product.discounts[0] && product.discounts[0].campaignId"
              >
                <div
                  v-for="(campaign, index) in product.discounts"
                  :key="index"
                >
                  <p
                    class="mb-0"
                    style="color: red"
                    v-if="campaign.originalPrice != campaign.discountPrice"
                  >
                    {{ campaign.discountText }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex align-center"
          :class="$vuetify.breakpoint.smAndDown ? 'pl-4' : ''"
        >
          <div>
            <div
              class="profile__container--content__orderhistory--details font-weight-bold"
            >
              <p>Pr. enhet</p>
            </div>
            <div
              :style="product.isDeleted ? 'text-decoration: line-through' : ''"
            >
              {{ ((itemDiscount(product).discounted ? itemDiscount(product).totalSalePrice : itemDiscount(product).salePrice) /
              product.quantity).toFixed(2).replace('.', ',') }}
            </div>
          </div>
          <div class="pl-5">
            <div
              class="profile__container--content__orderhistory--details font-weight-bold"
            >
              <p>Antall</p>
            </div>
            <div
            class="d-flex justify-center"
              :style="product.isDeleted ? 'text-decoration: line-through' : ''"
            >
              {{ product.quantity }}
            </div>
          </div>
          <div
            class="profile__container--content__orderhistory--details-price text-end"
            :style="
              $vuetify.breakpoint.mdAndUp ? 'width: 100px' : 'width: 80px'
            "
          >
            <p
              v-if="itemDiscount(product).discounted"
              class="mb-0 text-decoration-line-through"
              style="font-size: 14px; text-align: right"
            >
              {{
                itemDiscount(product).totalValue.toFixed(2).replace(".", ",")
              }}
            </p>
            <p
              class="mb-0"
              :class="['Cancelled'].includes(order.orderStatusId) || product.isDeleted ? 'text-decoration-line-through' : ''"
              :style="itemDiscount(product).discounted ? 'color: red' : ''">
              {{ (["Credited", "ReturnChecked", "NewReturn"].includes(order.orderStatusId) ? '-' : '') + (itemDiscount(product).discounted ? itemDiscount(product).totalSalePrice : itemDiscount(product).salePrice).toFixed(2).replace(".", ",") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      required: true,
      default: {},
      type: Object,
    },
    layout: {
      required: false,
      default: "chain",
      type: String,
    },
  },
  computed: {
    productsOrder() {
      return this.order.products;
    },
  },
  methods: {
    productDiscount(product) {
      var discount = 0;

      for (let discountProduct of product.discounts) {
        discount =
          discount +
          discountProduct.quantity * discountProduct.originalPrice -
          discountProduct.quantity * discountProduct.discountPrice;
      }
      return discount;
    },
    itemDiscount(product) {
      let salePrice = product.price;
      let totalPriceForQuantity = 0;
      let discountedQuantity = 0;
      let discountText = '';
      if (product.discounts.length) {
        product.discounts.forEach((discount) => {
          totalPriceForQuantity += discount.discountPrice * discount.quantity;
          discountedQuantity += discount.quantity;
          discountText = discount.discountText;
        });
      }
      if (discountedQuantity <= product.quantity && discountedQuantity > 0) {
        totalPriceForQuantity +=
        product.price * (product.quantity - discountedQuantity);
        salePrice =
          totalPriceForQuantity / (product.quantity + discountedQuantity);
      }
      return {
        salePrice: salePrice,
        price: product.price,
        totalSalePrice:
          totalPriceForQuantity,
        totalValue: product.price * product.quantity,
        discounted: discountedQuantity > 0,
        discountText: discountText,
      };
      return 0
    },
    productsTotalPrice(product) {
      return (product.price * product.quantity - this.itemDiscount(product).totalSalePrice)
        .toFixed(2)
        .replace(".", ",");
    },

    portalUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_URL
        : this.$config.VUE_APP_FIXIT_NO_URL
        ? this.$config.VUE_APP_FIXIT_NO_URL
        : this.$config.PORTAL_URL
        ? this.$config.PORTAL_URL
        : process.env.VUE_APP_FIXIT_NO_URL;
    },
    productRedirect(product) {
      window.open(
        `${this.portalUrl()}/nettbutikk/${this.order.salonInfo.chainId}/produkt/${product.urlSafeName}/${product.base64Id}`,
        "_self"
      );
    },
  },
};
</script>
